import { Backdrop, ButtonPrimary, ButtonTertiary, DialogConfirmation, } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';
import TextDir from '../lib/TextDir';
import { useTranslation } from 'react-i18next';
const Container = styled(Backdrop) `
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
`;
const DialogStyled = styled(DialogConfirmation) `
  max-width: 95%;
  margin: auto;
  background: white;
  color: black;
  & > div {
    border-block-end: 1px solid #dedede;
  }
  button {
    margin-inline-start: 1rem;
  }
`;
const CloseButton = styled(ButtonPrimary) `
  color: #fff;
  background-color: red;
  &&:hover {
    background-color: ${props => props.$hoverColor || '#3629ed'};
  }
`;
const ContinueButton = styled(ButtonTertiary) `
  &&:hover {
    color: black;
  }
`;
export const ChatBoxConfirmationDialog = ({ title, declineLabel, confirmLabel, onSubmit, isOpen, hoverColor, }) => {
    const { i18n } = useTranslation();
    return isOpen ? (React.createElement(Container, null,
        React.createElement(DialogStyled, { "aria-label": "Confirmation dialog", "data-testid": "chat-box-confirmation-dialog", dialogTitle: title, dir: i18n.dir(), footer: React.createElement(React.Fragment, null,
                React.createElement(ContinueButton, { "data-testid": "chat-box-confirmation-dialog-tertiary-button", size: "small", condensed: true, onClick: () => onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit('decline') },
                    React.createElement(TextDir, { locale: i18n.language }, declineLabel)),
                React.createElement(CloseButton, { "data-testid": "chat-box-confirmation-dialog-primary-button", size: "small", onClick: () => onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit('confirm'), "$hoverColor": hoverColor },
                    React.createElement(TextDir, { locale: i18n.language }, confirmLabel))) }))) : null;
};
//# sourceMappingURL=ChatBoxConfirmationDialog.js.map